module.exports = __webpack_public_path__ + "static/media/36.177bb7d7.png";